import { Radio, SelectionStatus } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const BasisSwitch = ({ basis, setBasis, style = { display: 'flex' } }) => {
    const onChangeBasis = React.useCallback((event) => {
        const target = event.target;
        setBasis(target.name);
    }, [setBasis]);
    console.log("BASIS: %o", basis);
    return (React.createElement("div", { style: style },
        React.createElement(Radio, { label: "Spread", name: 'spread', onChange: onChangeBasis, status: basis === 'spread' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: '' }),
        React.createElement(Radio, { label: "Yield", name: 'yield', onChange: onChangeBasis, status: basis === 'yield' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: '' }),
        React.createElement(Radio, { label: "Coupon / Price", name: 'priceCoupon', onChange: onChangeBasis, status: basis !== 'spread' && basis !== 'yield' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: '' })));
};
export default BasisSwitch;
